import { render, staticRenderFns } from "./FileUploadCenter.vue?vue&type=template&id=3f0e5c97&scoped=true"
import script from "./FileUploadCenter.vue?vue&type=script&lang=js"
export * from "./FileUploadCenter.vue?vue&type=script&lang=js"
import style0 from "./FileUploadCenter.vue?vue&type=style&index=0&id=3f0e5c97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0e5c97",
  null
  
)

export default component.exports